export default function getContractType(value: number): string {
  switch (value) {
    case 1:
      return "Temporário";
    case 2:
      return "Efetivo";
    case 3:
      return "Estagiário";
    case 4:
      return "Sem Registro";
    case 5:
      return "PJ (Pessoa Jurídica)";
    default:
      return "Valor inválido";
  }
}
